import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);
const LANG_KEY = "mhc_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(LANG_KEY) || "en");

  useEffect(() => { localStorage.setItem(LANG_KEY, lang); }, [lang]);

  const setLang = (l) => setLangState(l);
  const toggle = () => setLangState((l) => (l === "en" ? "hi" : "en"));

  const t = (key, vars) => {
    const dict = translations[lang] || translations.en;
    let val = dict[key];
    if (val === undefined) val = translations.en[key];
    if (val === undefined) return key;
    if (typeof val === "string" && vars) {
      Object.entries(vars).forEach(([k, v]) => { val = val.replace(`{${k}}`, v); });
    }
    return val;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
